const REPORT_CONFIG = {
  1: {
    kind: 'debit',
    restitution: false,
    fileName: 'IvaSimpleDF',
    headers: [
      'Actividad',
      ' Tipo de Operacion',
      ' Tipo de sujeto comprador',
      ' Codigo de Alicuota',
      ' Monto Neto Gravado',
      ' Debito Fiscal Facturado',
      ' Debito Fiscal Operacion Dacion en Pago',
      ' Monto Neto Exento o No Gravado'
    ]
  },
  2: {
    kind: 'debit',
    restitution: true,
    fileName: 'IvaSimpleDFRestitucion',
    headers: [
      'Actividad',
      ' Tipo de Operacion',
      ' Tipo de sujeto comprador',
      ' Codigo de Alicuota',
      ' Monto Neto Gravado',
      ' Debito Fiscal a Restituir',
      ' Monto Neto Exento o No Gravado'
    ]
  },
  3: {
    kind: 'credit',
    restitution: false,
    fileName: 'IvaSimpleCF',
    headers: [
      'Concepto',
      ' Codigo de Alicuota',
      ' Monto Neto Gravado',
      ' Credito Fiscal Facturado',
      ' Credito Fiscal Computable'
    ]
  },
  4: {
    kind: 'credit',
    restitution: true,
    fileName: 'IvaSimpleCFRestitucion',
    headers: [
      'Concepto',
      ' Codigo de Alicuota',
      ' Monto Neto Gravado',
      ' Credito Fiscal Facturado'
    ]
  }
}

const RATE_CODES = [
  { rate: 0, code: 3 },
  { rate: 2.5, code: 9 },
  { rate: 5, code: 8 },
  { rate: 10.5, code: 4 },
  { rate: 21, code: 5 },
  { rate: 27, code: 6 }
]

const TAX_FIELDS_BY_RATE = {
  9: ['SumaDeIVA9'],
  8: ['SumaDeIVA19'],
  4: ['SumaDeIVA10'],
  5: ['SumaDeIVA21'],
  6: ['SumaDeIVA27']
}

const CONCEPT_CODES = {
  BIENES: 1,
  LOCACION: 2,
  SERVICIOS: 3,
  'INVERSIONES DE BIENES DE USO': 4,
  'COMPRA BU A CF': 4
}

function toNumber(value) {
  if (value === null || value === undefined || value === '') return null
  const parsed = typeof value === 'string'
    ? Number(value.replace(',', '.'))
    : Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

function normalize(value) {
  return String(value || '').trim().toUpperCase()
}

function signedValue(value, restitution) {
  const parsed = toNumber(value)
  if (parsed === null) return 0
  return restitution ? Math.abs(parsed) : parsed
}

function getReportConfig(tipo) {
  const config = REPORT_CONFIG[Number(tipo)]
  if (!config) throw new Error('El tipo de reporte IVA seleccionado no tiene formato CSV configurado.')
  return config
}

function getRateCode(row) {
  const existingCode = toNumber(row.CodigoAlicuota || row.codigo_alicuota)
  if (existingCode !== null && RATE_CODES.some(item => item.code === existingCode)) {
    return existingCode
  }

  const rate = toNumber(row.TasaDeIVA)
  if (rate === null) return null

  const match = RATE_CODES.find(item => Math.abs(item.rate - rate) < 0.01)
  return match ? match.code : null
}

function getTaxAmount(row, rateCode, legacy) {
  if (rateCode === 3) return 0

  const fields = TAX_FIELDS_BY_RATE[rateCode] || []
  for (const field of fields) {
    const value = toNumber(row[field])
    if (value !== null && (legacy || value !== 0)) return value
  }

  if (legacy) {
    // Empresa 1 (GM) debit and the default behavior keep the original chain: as-is.
    const variableTax = toNumber(row.SumaDeTasaVariable)
    return variableTax === null ? 0 : variableTax
  }

  if (rateCode === 9 || rateCode === 8) {
    // Reduced rates (2.5% / 5%) are commented as "2,50%", "02,50%", "5,00%",
    // etc. and land in SumaDeTasaVariable; the comprobante total is the last
    // resort when a view misses the comment variant.
    const variableTax = toNumber(row.SumaDeTasaVariable)
    if (variableTax !== null && variableTax !== 0) return variableTax
    const totalTax = toNumber(row.IVA)
    return totalTax === null ? 0 : totalTax
  }

  return 0
}

function getActivity(row) {
  const candidates = [row.Actividad, row.actividad, row.ClasifIIBB, row.Clasificacion]
  for (const candidate of candidates) {
    const match = String(candidate || '').match(/^\s*(\d{6})\b/)
    if (match) return match[1]
  }
  throw new Error('No se pudo determinar la actividad de una fila del reporte IVA.')
}

function getBuyerCode(row) {
  const buyerType = normalize(row.Condicion || row.TipoIVA)
  if (buyerType.includes('MONOTRIB')) return 2
  if (
    buyerType.includes('RESPONSABLE INSCRIPTO') ||
    buyerType.includes('RESPONSABLE NO INSCRIPTO') ||
    buyerType.includes('GRAN CONTRIBUYENTE')
  ) {
    return 1
  }
  return 3
}

function getConceptCode(row) {
  const classification = normalize(row.Clasificacion)
  const code = CONCEPT_CODES[classification]
  if (!code) {
    throw new Error(`No se pudo determinar el concepto IVA para "${row.Clasificacion || ''}".`)
  }
  return code
}

function documentMatches(row, restitution, legacy) {
  if (legacy) {
    // Empresa 1 (GM) debit and the default behavior keep the original filter:
    // no Documento passes, otherwise FC (or NC for restitution) only.
    if (!row.Documento) return true
    return normalize(row.Documento) === (restitution ? 'NC' : 'FC')
  }

  // The system reports build the "FC" bucket with `Documento <> 'NC'` (it also
  // includes ND and BU) and the "NC" bucket with `Documento = 'NC'`; Eudy debit
  // and both companies' credit split the same way to match the reports.
  const document = normalize(row.Documento)
  if (!document) return false
  return restitution ? document === 'NC' : document !== 'NC'
}

function addGroup(groups, key, initialValue) {
  if (!groups.has(key)) groups.set(key, initialValue)
  return groups.get(key)
}

function buildDebitRows(rows, config, legacy, empresa) {
  const groups = new Map()

  rows
    .filter(row => {
      if (empresa === 1) {
        const document = normalize(row.Documento)
        if (config.restitution) return document === 'NC'
        if (document === 'ND') return true
      }
      return documentMatches(row, config.restitution, legacy)
    })
    .forEach(row => {
      const activity = getActivity(row)
      const rateCode = getRateCode(row)
      const netAmount = signedValue(row.Gravado, config.restitution)
      const exemptAmount = signedValue(row.Exento, config.restitution)

      if (Math.abs(netAmount) > 0 && rateCode !== null) {
        const buyerCode = getBuyerCode(row)
        const operationCode = 1
        const key = [activity, operationCode, buyerCode, rateCode].join('|')
        const group = addGroup(groups, key, {
          activity,
          operationCode,
          buyerCode,
          rateCode,
          netAmount: 0,
          taxAmount: 0
        })
        group.netAmount += netAmount
        group.taxAmount += signedValue(getTaxAmount(row, rateCode, legacy), config.restitution)
      }

      if (Math.abs(exemptAmount) > 0) {
        const operationCode = config.restitution ? 2 : 3
        const key = [activity, operationCode].join('|')
        const group = addGroup(groups, key, {
          activity,
          operationCode,
          exemptAmount: 0
        })
        group.exemptAmount += exemptAmount
      }
    })

  return Array.from(groups.values())
    .sort((a, b) => {
      if (a.activity !== b.activity) return a.activity.localeCompare(b.activity)
      if (a.operationCode !== b.operationCode) return a.operationCode - b.operationCode
      return (a.buyerCode || 0) - (b.buyerCode || 0) || (a.rateCode || 0) - (b.rateCode || 0)
    })
    .map(row => {
      if (config.restitution && row.operationCode === 2) {
        return [row.activity, row.operationCode, '', '', '', '', row.exemptAmount]
      }

      if (!config.restitution && row.operationCode === 3) {
        return [row.activity, row.operationCode, '', '', '', '', '', row.exemptAmount]
      }

      if (config.restitution) {
        return [
          row.activity,
          row.operationCode,
          row.buyerCode,
          row.rateCode,
          row.netAmount,
          row.taxAmount,
          ''
        ]
      }

      return [
        row.activity,
        row.operationCode,
        row.buyerCode,
        row.rateCode,
        row.netAmount,
        row.taxAmount,
        '',
        ''
      ]
    })
}

function getComputableAmount(row, facturado) {
  const explicitValue = [
    row.CreditoFiscalComputable,
    row.credito_fiscal_computable,
    row.Credito_fiscal_computable
  ].find(value => value !== null && value !== undefined && value !== '')
  // The current IVA detail response does not expose this field; use invoiced credit until it does.
  return explicitValue === undefined ? facturado : explicitValue
}

// Tax buckets a comprobante's accounting entry can carry, with the portal's
// alícuota code and the rate used to rebuild the net base when a comprobante
// mixes rates (SAI keeps a single header rate, sometimes left unset as 0%).
const TAX_BUCKETS = [
  { code: 5, field: 'SumaDeIVA21', rate: 21 },
  { code: 4, field: 'SumaDeIVA10', rate: 10.5 },
  { code: 6, field: 'SumaDeIVA27', rate: 27 }
]

function getTaxBuckets(row) {
  return TAX_BUCKETS
    .map(bucket => ({ ...bucket, tax: toNumber(row[bucket.field]) }))
    .filter(bucket => bucket.tax !== null && bucket.tax !== 0)
}

function hasCreditAmount(row) {
  return [
    row.Gravado,
    row.SumaDeIVA9,
    row.SumaDeIVA19,
    row.SumaDeIVA10,
    row.SumaDeIVA21,
    row.SumaDeIVA27,
    row.SumaDeTasaVariable,
    row.IVA,
    row.CreditoFiscalComputable,
    row.credito_fiscal_computable,
    row.Credito_fiscal_computable
  ].some(value => {
    if (value === null || value === undefined || value === '') return false
    const amount = toNumber(value)
    return amount === null || amount !== 0
  })
}

function round2(value) {
  return Math.round(value * 100) / 100
}

function addCreditGroup(groups, conceptCode, rateCode, netAmount, facturado, computable) {
  const key = [conceptCode, rateCode].join('|')
  const group = addGroup(groups, key, {
    conceptCode,
    rateCode,
    netAmount: 0,
    facturado: 0,
    computable: 0
  })
  group.netAmount += netAmount
  group.facturado += facturado
  group.computable += computable
}

function getCreditNetAmount(row, rateCode, facturado, restitution) {
  // The Credito_Fiscal report derives each rate's base as SUM(tax) * 100 / rate;
  // declaring the same base keeps the portal's net comparison aligned. Reduced
  // rates (8/9) and 0% keep the stored Gravado.
  if (rateCode === 4 || rateCode === 5 || rateCode === 6) {
    const rate = RATE_CODES.find(item => item.code === rateCode).rate
    return facturado * 100 / rate
  }
  return signedValue(row.Gravado, restitution)
}

function buildCreditRows(rows, config) {
  const groups = new Map()

  rows
    .filter(row => documentMatches(row, config.restitution, false))
    .forEach(row => {
      // Credit CSV has no exempt column; retain any taxable or credit-bearing row.
      if (!hasCreditAmount(row)) return
      const conceptCode = getConceptCode(row)
      const rateCode = getRateCode(row)

      if (rateCode === 3 || rateCode === null) {
        // Comprobantes flagged as 0% (or without a rate) whose accounting entry
        // carries taxed buckets — the SAI header rate was never set. They must
        // be declared under their real alícuotas, and the portal expects no 0%
        // credit line for them.
        const buckets = getTaxBuckets(row)
        if (buckets.length > 0) {
          const netAmount = signedValue(row.Gravado, config.restitution)
          buckets.forEach(bucket => {
            const bucketNet = signedValue(
              buckets.length === 1 ? netAmount : round2(Math.abs(bucket.tax) * 100 / bucket.rate),
              config.restitution
            )
            const facturado = signedValue(bucket.tax, config.restitution)
            const computable = signedValue(getComputableAmount(row, facturado), config.restitution)
            addCreditGroup(groups, conceptCode, bucket.code, bucketNet, facturado, computable)
          })
          return
        }
      }

      if (rateCode === null) return

      const facturado = signedValue(getTaxAmount(row, rateCode, false), config.restitution)
      const netAmount = getCreditNetAmount(row, rateCode, facturado, config.restitution)
      const computable = signedValue(getComputableAmount(row, facturado), config.restitution)
      if (Math.abs(netAmount) === 0 && Math.abs(facturado) === 0) return

      addCreditGroup(groups, conceptCode, rateCode, netAmount, facturado, computable)
    })

  return Array.from(groups.values())
    .sort((a, b) => a.rateCode - b.rateCode || a.conceptCode - b.conceptCode)
    .map(row => config.restitution
      ? [row.conceptCode, row.rateCode, row.netAmount, row.facturado]
      : [row.conceptCode, row.rateCode, row.netAmount, row.facturado, row.computable]
    )
}

function formatNumber(value) {
  const parsed = toNumber(value)
  if (parsed === null) return ''
  const rounded = Number(parsed.toFixed(2))
  return String(Object.is(rounded, -0) ? 0 : rounded).replace('.', ',')
}

function serializeRow(row) {
  return row.map(value => typeof value === 'number' ? formatNumber(value) : String(value || '')).join(';')
}

export function buildIvaSimpleCsv(tipo, rows = [], options = {}) {
  const config = getReportConfig(tipo)
  // Debit keeps each company's document handling (GM: FC/ND with empty documents;
  // Eudy: non-NC split). Credit mirrors the Credito_Fiscal report for both
  // companies: non-NC documents and bucket redistribution for mistyped headers.
  const empresa = Number(options.empresa)
  const legacy = empresa !== 2
  const dataRows = config.kind === 'debit'
    ? buildDebitRows(rows, config, legacy, empresa)
    : buildCreditRows(rows, config)
  return [config.headers, ...dataRows].map(serializeRow).join('\r\n') + '\r\n'
}

export function getIvaSimpleFilename(tipo, periodo) {
  const config = getReportConfig(tipo)
  const [month, year] = String(periodo || '').split('/')
  const periodSuffix = year && month ? `${year}_${Number(month)}` : 'reporte'
  return `${config.fileName}_${periodSuffix}.csv`
}
